import React from 'react';

// Classnames
import clsx from 'clsx';

// Interface
interface IDescriptionProps {
	description: string;
}

export const Description: React.FC<IDescriptionProps> = (props) => {
	const { description } = props;

	const cnTitle = clsx(
		'pfizer__description',
		!!description ? 'mb5' : ''
	);
	return (
		<div className="pfizer__description-bg">
			<h4 className={cnTitle}>
				Pfizer compound category
			</h4>
			{!!description &&
				<p
					className="pfizer__description-text"
					dangerouslySetInnerHTML={{ __html: description || '' }}
				/>}
		</div>
	);
};

export default Description;
